// Column-size limits mirrored from the database schema. Keep in sync with
// crm-backend/src/utils/fieldLimits.js (the backend re-validates everything;
// `npm run check:limits` in crm-backend verifies against the live schema).
export const LIMITS = {
  contacts: {
    first_name: 100, last_name: 50, designation: 100, email: 50, mobile: 15, company: 250,
    company_gst: 100, city: 100, zip: 50
  },
  contact_persons: { contact_person: 199, contact_mobile: 15, contact_email: 50 },
  services: { service_name: 100, hsn_sac: 10 },
  tax: { tax_name: 100 },
  users: {
    username: 50, email: 100, password: 15, first_name: 50, last_name: 50, phone: 20
  },
  proforma_invoices: { tax_invoice_no: 50 }
};

// DECIMAL(10,2) columns hold at most 99,999,999.99.
export const DECIMAL_10_2_MAX = 99999999.99;
export const INT_MAX = 2147483647;
export const PERCENT_MAX = 100;
export const TEXT_MAX = 65535;

/** maxLength for an <input>: limitFor('contacts', 'email') */
export const limitFor = (table, field) => (LIMITS[table] ? LIMITS[table][field] : undefined);

/** Error message when the value is longer than the column allows, else ''. */
export function lengthError(table, field, value, label) {
  const max = limitFor(table, field);
  if (!max || value === undefined || value === null) return '';
  return String(value).length > max ? `${label} must not exceed ${max} characters` : '';
}

/** Error message when `value` is not a finite number within [min, max], else ''. */
export function numberError(value, { label, min = 0, max = DECIMAL_10_2_MAX, integer = false } = {}) {
  if (value === undefined || value === null || value === '') return '';
  const n = Number(value);
  if (!Number.isFinite(n)) return `${label} must be a valid number`;
  if (integer && !Number.isInteger(n)) return `${label} must be a whole number`;
  if (n < min) return `${label} must not be less than ${min}`;
  if (n > max) return `${label} must not exceed ${max.toLocaleString('en-US', { maximumFractionDigits: 2 })}`;
  return '';
}
